import { ChangeDetectionStrategy,Component, Input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'photo-source-actions-menu',
    standalone: true,
    imports: [MatIconButton, MatMenuTrigger, MatMenu, MatMenuItem, MatIcon],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './photo-source-actions-menu.component.html'
})
export class PhotoSourceActionsMenuComponent {
    @Input() enabled: boolean = true; // default considered enabled
    @Input() enableAction?: () => void;
    @Input() disableAction?: () => void;
    @Input() editAction?: () => void;
    @Input() deleteAction?: () => void;
    @Input() translateAction?: () => void;
}
